import { eventBus } from 'frontend/communications/eventBus'
import { getVirtualTrainingStats, getVirtualTrainingWorkstationStats } from 'frontend/communications/stats'

const stateObj = {
  virtualTrainingStats: null,
  virtualTrainingWorkstationStats: null,
}

const getters = {
  virtualTrainingStats (state) {
    return state.virtualTrainingStats
  },
  virtualTrainingWorkstationStats (state) {
    return state.virtualTrainingWorkstationStats
  },
}

const mutations = {
  setVirtualTrainingStats (state, virtualTrainingStats) {
    state.virtualTrainingStats = virtualTrainingStats
  },
  setVirtualTrainingWorkstationStats (state, virtualTrainingWorkstationStats) {
    state.virtualTrainingWorkstationStats = virtualTrainingWorkstationStats
  },
}

const actions = {
  resetVirtualTrainingStats ({ commit }) {
    commit('setVirtualTrainingStats', null)
  },
  resetVirtualTrainingWorkstationStats ({ commit }) {
    commit('setVirtualTrainingWorkstationStats', null)
  },
  fetchVirtualTrainingStats ({ commit }, payload) {
    eventBus.fetchingVirtualTrainingStats(true)
    getVirtualTrainingStats(payload['perimeterIds'], payload['variantId'], payload['isVTAutonomous'])
      .then((data) => {
        commit('setVirtualTrainingStats', data)
        eventBus.fetchingVirtualTrainingStats(false)
      })
  },
  fetchVirtualTrainingWorkstationStats ({ commit }, payload) {
    getVirtualTrainingWorkstationStats(payload['perimeterIds'])
      .then((data) => {
        commit('setVirtualTrainingWorkstationStats', data)
      })
  },
}

export default {
  state: stateObj,
  getters,
  mutations,
  actions,
}
